module.exports = __webpack_public_path__ + "static/gate1-46fc707910cd771e87eceed13c6f62c6.jpg";